const config = {
    api: (process.env.REACT_APP_API_BASEURL || 'http://54.82.101.184:3000/api'),
}

export default config;